export const iconFontAwesomeShoppingThumbsDown = (
	<i className="fa-solid fa-thumbs-down"></i>
);
